import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Lock, CalendarCheck } from "lucide-react";

const BOOK_DEMO_URL = "mailto:contact@push2stream.com?subject=MOXYPLAY%20demo%20request";

export default function Signup() {
  return (
    <div className="min-h-screen bg-background text-foreground brand-hero-bg grain relative overflow-hidden flex flex-col">
      {/* Aurora blobs */}
      <div className="absolute -top-40 -right-40 w-[620px] h-[620px] rounded-full opacity-30 pointer-events-none" style={{ background: "radial-gradient(circle, rgba(139,92,246,0.55), transparent 65%)" }} />
      <div className="absolute -bottom-40 -left-40 w-[560px] h-[560px] rounded-full opacity-25 pointer-events-none" style={{ background: "radial-gradient(circle, rgba(34,211,238,0.5), transparent 65%)" }} />

      <div className="relative px-6 py-4 flex items-center justify-between">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors" data-testid="signup-back-home">
          <ArrowLeft className="w-4 h-4" /> Back to site
        </Link>
        <div className="flex items-center gap-2">
          <div className="h-8 w-8 rounded-lg overflow-hidden p-1 flex items-center justify-center" style={{ background: "var(--brand-bg-deep)", boxShadow: "0 0 12px rgba(139,92,246,0.35)" }}>
            <img src="https://customer-assets-jt897jd0.emergentagent.net/job_broadcast-cloud-2/artifacts/jeb6uhlp_FullLogo_Transparent_NoBuffer.png" alt="MOXYPLAY" className="w-full h-full object-contain" />
          </div>
          <div className="font-display font-black text-sm text-gradient tracking-tight">MOXYPLAY</div>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center px-6 pb-12 relative">
        <div className="w-full max-w-md glass-card p-8 sm:p-10 text-center" data-testid="signup-closed-card">
          <div className="inline-flex items-center gap-2 gradient-stroke rounded-full px-3 py-1 text-[10px] uppercase tracking-widest font-mono text-foreground/80 mb-6">
            <Lock className="w-3 h-3 text-fuchsia-400" /> Sign-up closed
          </div>
          <h1 className="font-display font-black text-3xl tracking-tighter">Public sign-up is closed</h1>
          <p className="text-muted-foreground text-sm mt-3 leading-relaxed">
            MOXYPLAY workspaces are provisioned by our team. Book a demo and we'll set you up with a
            channel tailored to your operation.
          </p>

          <a href={BOOK_DEMO_URL} data-testid="signup-book-demo-btn">
            <Button className="w-full tenant-btn rounded-full h-11 mt-8">
              <CalendarCheck className="w-4 h-4 mr-2" /> Book a demo
            </Button>
          </a>

          <div className="mt-6 text-center text-sm text-muted-foreground">
            Already have an account?{" "}
            <Link to="/login" className="text-foreground underline hover:text-cyan-400" data-testid="signup-to-login-link">Sign in</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
